import React from 'react';
import axios from "../../../../containers/api";
import {showCatchError, toEnglishNumbers} from "../../../../helpers/Utils";
import {Badge, CardBody, CardTitle, FormGroup, Input, Label} from "reactstrap";

class CarSmartCard extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            id: this.props.carSmartCard,
            smartCard: null
        };
    }

    componentDidMount() {
        this.do();
    }

    componentWillReceiveProps(nextProps) {
        if (this.props !== nextProps) {
            this.setState({id: this.props.carSmartCard});
        }
    }

    do = () => {
        this.props.showSpinner();
        axios.get('api/DriverApi/InquirCarSmartCard?carSmartCard=' + toEnglishNumbers(this.state.id))
            .then((res) => {
                this.props.hideSpinner();
                if (res.data === null) {
                    this.props.showAlert("هیچ اطلاعاتی موجود نیست", "info");
                } else {
                    this.setState({smartCard: res.data});
                    this.props.showAlert("کد هوشمند معتبر می‌باشد", "success");
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
    };

    render() {
        return (
            <CardBody>
                <CardTitle>
                    نتیجه استعلام کد هوشمند ناوگان
                </CardTitle>

                <div className="d-flex flex-md-row flex-column flex-wrap justify-content-center align-items-center">
                    <FormGroup className="w-md-25 w-100 px-1">
                        <Label>کد هوشمند ناوگان</Label>
                        <Input value={this.state.smartCard && this.state.smartCard.loadingTypeTitle} readOnly/>
                    </FormGroup>

                    <FormGroup className="w-md-25 w-100 px-1">
                        <Label>کشنده</Label>
                        <Input value={this.state.smartCard && this.state.smartCard.name} readOnly/>
                    </FormGroup>

                    <FormGroup className="w-md-25 w-100 px-1">
                        <Label>شماره پلاک</Label>
                        <Input value={this.state.smartCard && this.state.smartCard.plaqueNumber} readOnly/>
                    </FormGroup>

                    <FormGroup className="w-md-25 w-100 px-1">
                        <Label>سریال پلاک</Label>
                        <Input value={this.state.smartCard && this.state.smartCard.plaqueSerialNumber} readOnly/>
                    </FormGroup>

                    <FormGroup className="w-md-25 w-100 px-1">
                        <Label>سال ساخت</Label>
                        <Input value={this.state.smartCard && this.state.smartCard.madeYear} readOnly/>
                    </FormGroup>

                    <FormGroup className="w-md-25 w-100 px-1">
                        <Label>تلفن همراه</Label>
                        <Input value={this.state.smartCard && this.state.smartCard.mobile} readOnly/>
                    </FormGroup>

                    <FormGroup className="w-md-25 w-100 px-1">
                        <Label>تاریخ اعتبار معاینه فنی</Label>
                        <Input value={this.state.smartCard && this.state.smartCard.tarikH_ETEBAR_MOAYENE_FANI} readOnly/>
                    </FormGroup>

                    <FormGroup className="w-md-25 w-100 px-1">
                        <Label>شماره VIN</Label>
                        <Input value={this.state.smartCard && this.state.smartCard.vinCode} readOnly/>
                    </FormGroup>

                    <FormGroup className="w-md-25 w-100 px-1 d-flex flex-column">
                        <Label>وضعیت</Label>
                        <h4>
                            {this.state.smartCard && this.state.smartCard.isActive === true ?
                                <Badge color="success" className="text-center w-100">فعال</Badge>
                                :
                                <Badge color="danger" className="text-center w-100">غیرفعال</Badge>
                            }
                        </h4>
                    </FormGroup>
                </div>
            </CardBody>
        );
    }
}

export default CarSmartCard;
